import React from 'react';
import PropTypes from 'prop-types';
import { MessageBar, MessageBarType, MessageBarButton, mergeStyleSets } from '@fluentui/react';
import { DefaultLayerHostZ } from 'src/components/base/OverlayProgress';

const classNames = mergeStyleSets({
  root: {
    width: '100%',
    backgroundColor: 'white',
  },
})

export const Type = {
  Error: MessageBarType.error,
  Warning: MessageBarType.warning,
  Success: MessageBarType.success,
  Info: MessageBarType.info,
};

const Colors = {
  [Type.Error]: '#fde7e9',
  [Type.Warning]: '#fff4ce',
  [Type.Success]: '#dff6dd',
  [Type.Info]: ['#f3f2f1'],
};

const MessagePane = ({ message, messageType, buttons, onDismiss }) => {
  const type = messageType ?? Type.Error;
  return (
    <div className={classNames.root} onClick={onDismiss}>
      <MessageBar
        isMultiline={true}
        dismissButtonAriaLabel='Close'
        messageBarType={type}
        actions={buttons && !!buttons.length &&
          <div>
            { buttons.map(({ text, onClick }, index) =>
              <MessageBarButton key={index} styles={{ root: { backgroundColor: Colors[type] } }} onClick={onClick}>{text}</MessageBarButton> )
            }
          </div>
        }
        onDismiss={onDismiss}>
          <span dangerouslySetInnerHTML={{ __html: message.replace(/\n/g, '<br />') }} />
      </MessageBar>
    </div>
  );
}

MessagePane.propTypes = {
  message: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default MessagePane;